import styled from "styled-components";

const AccountsStyle = styled.div.attrs((props) => ({
  className: props.className,
}))``;

export default AccountsStyle;
